import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import { realtime } from '../config/config'
import { fetchCsrfCookie } from '../utils/csrfCookie'
;(window as any).Pusher = Pusher

function getCsrfTokenFromCookie(): string | undefined {
  const m = document.cookie.match(/(?:^|; )XSRF-TOKEN=([^;]+)/)
  return m ? decodeURIComponent(m[1]) : undefined
}

export async function ensureCsrfCookie(): Promise<void> {
  await fetchCsrfCookie(realtime.apiUrl)
}

export const echo = new Echo({
    broadcaster: 'pusher',
    cluster: 'mt1',
    key: realtime.reverbKey,
    wsHost: realtime.reverbHost,
    wsPort: realtime.reverbPort,
    wssPort: realtime.reverbPort,
    forceTLS: realtime.reverbScheme === 'https',
    enabledTransports: ['ws', 'wss'],
    disableStats: true,
    authorizer: (channel: any) => ({
      authorize: async (socketId: string, cb: (err: Error | null, data?: any) => void) => {
        try {
          await ensureCsrfCookie()
          const headers: Record<string, string> = {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          }
          const csrf = getCsrfTokenFromCookie()
          if (csrf) headers['X-XSRF-TOKEN'] = csrf

          const res = await fetch(`${realtime.apiUrl}/broadcasting/auth`, {
            method: 'POST',
            credentials: 'include',
            headers,
            body: JSON.stringify({ socket_id: socketId, channel_name: channel.name }),
          })

          if (!res.ok) {
            const text = await res.text().catch(() => '')
            return cb(new Error(`Auth failed (${res.status}): ${text || res.statusText}`))
          }
          const data = await res.json().catch(() => null)
          cb(null, data)
        } catch (err) {
          cb(err instanceof Error ? err : new Error(String(err)))
        }
      },
    }),
  })

;(window as any).echo = echo
